var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"hv-navmenu",attrs:{"default-active":this.$route.path,"router":"","mode":_vm.vertical?'vertical':'horizontal'}},[_c('navBar',_vm._g({attrs:{"list":_vm.list}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }